var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18.0 20.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar_i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar_i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0 L5,2 L13,2 L13,0 L15,0 L15,2 L16,2 C17.1,2 18,2.9 18,4 L18,18 C18,19.1 17.1,20 16,20 L2,20 C0.89,20 0,19.1 0,18 L0.01,4 C0.01,2.9 0.89,2 2,2 L3,2 L3,0 L5,0 Z M16,7 L2,7 L2,18 L16,18 L16,7 Z M6,9 L6,11 L4,11 L4,9 L6,9 Z M10,9 L10,11 L8,11 L8,9 L10,9 Z M14,9 L14,11 L12,11 L12,9 L14,9 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-231.0 -408.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendar_i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.9999999999986 406.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.0 2.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendar_i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 18,0 18,20 0,20 0,0",
    stroke: "none",
    fill: "currentColor"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.707d5787e555b7cd92279a1e15a5604e.svg";
export { ForwardRef as ReactComponent };